import { Typography, Box, BoxProps } from '@mui/material';
import { styled } from '@mui/material/styles';

import Image from '../../../components_sunnyside/image';
import FiveStarReview from '../../../../public/img/sunnyside/five_star_review.png';
import { colors } from '../../../styles/_colors';
import SunnysideGrid from '../../../components_sunnyside/grid';
import HalfSun from '../../../../public/icons/sunnyside/half-sun';
import { PrismicReview } from '../../../utils/prismic/types/pages/page-data.type';

interface ReviewsFavoritesProps {
    reviews: PrismicReview[]
}

export default function ReviewsFavorites(props: ReviewsFavoritesProps): JSX.Element {
    const { reviews } = props;
    const Row = styled(Box)<BoxProps>(({ theme }) => ({
        [theme.breakpoints.down('md')]: {
            display: 'flex',
            flexDirection: 'row',
            width: '100%',
            flexWrap: 'wrap',
        },
        [theme.breakpoints.up('md')]: {
            columnCount: 2,
            columnGap: 0
        },
    }));
    const Column = styled(Box)<BoxProps>(({ theme }) => ({
        padding: '1rem',
        [theme.breakpoints.down('md')]: {
            display: 'flex',
            flexDirection: 'column',
            flexBasis: '100%',
            paddingBottom: '2rem',
            flex: '100%',
        },
        [theme.breakpoints.up('md')]: {
            display: 'inline-block',
            width: '100%'
        },
    }));

    const ReviewBox = styled(Box)<BoxProps>(({ theme }) => ({
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'flex-start',
        borderRadius: '1.25rem',
        background: colors.cloud,
        padding: '3.125rem 2rem',
    })); 

    return (
        <SunnysideGrid maxwidthwrapper background={colors.beige}>
            <Box display='flex'
                flexDirection='column'
                alignItems='center'
                paddingBottom='3.5rem'>
                <HalfSun />
                <Typography variant='h2'
                    paddingTop='1rem'
                    paddingBottom='1rem'
                    textAlign='center'>
                    Some of our favorite reviews
                </Typography>
                <Typography variant='body2'
                    textAlign='center'
                    color={colors.pine}>
                    We&apos;re obsessed with our customers and love to read what
                    they have to say. Here are some of our favorite reviews.
                </Typography>
            </Box>
            <Row>
                {reviews.map((review, index) => {
                    return (
                        <Column key={index}>
                            <ReviewBox>
                                <Image src={FiveStarReview}
                                    alt='Five orange stars' 
                                    width='240'
                                    height='40'
                                    objectFit='cover'/>
                                <Typography variant='h3'
                                    color={colors.black}
                                    fontWeight={700}
                                    paddingTop='1.5rem'
                                    paddingBottom='1.5rem'>
                                    {review.headline}
                                </Typography>
                                <Typography variant='body2'>
                                    {review.full_quote}
                                    <br/><br/>
                                    —{review.name}
                                </Typography>
                            </ReviewBox>
                        </Column>
                    );
                })}
            </Row>
        </SunnysideGrid>
    );
}